import React from "react";
import SocialMedia from "../molecules/SocialMedia";
import QuestionWithAnswer from "../molecules/QuestionWithAnswer";
import Link from "../atoms/Link";
import { FAQ } from "../../api/contentTypes";

export default ({ className = '', title, links, listSocialMedia = false }) => {

    if( !links ) {
        return null
    }

    const listElement = links.map((item, index) => {

        const contentType = item.contentType;

        if(contentType === FAQ) {
            return (
                <QuestionWithAnswer
                    question={ item.question }
                    answer={ item.answer }
                    key={ index }
                />
            )
        }

        if (listSocialMedia) {
            return (
                <SocialMedia
                    className={ " o-link-block__link" }
                    url={ item.link }
                    title={ item.socialMediaTitle }
                    key={ index }
                />
            );
        }

        return <Link className="o-link-block__link" link={ item } key={ index }/>;
    });

    return (
        <div className={ "o-link-block" + className }>
            {title && <div className="heading heading--fsb">{ title }</div> }
            <div className="o-link-block__list">
                { listElement }
            </div>
        </div>
    );
}

